__turbopack_context__.v({
  "backdrop": "BgBlurredTextRingPro-module__umZRfq__backdrop",
  "config": "BgBlurredTextRingPro-module__umZRfq__config",
  "configContents": "BgBlurredTextRingPro-module__umZRfq__configContents",
  "content": "BgBlurredTextRingPro-module__umZRfq__content",
  "content2": "BgBlurredTextRingPro-module__umZRfq__content2",
  "contentOne": "BgBlurredTextRingPro-module__umZRfq__contentOne",
  "contentTwo": "BgBlurredTextRingPro-module__umZRfq__contentTwo",
  "heroTitle": "BgBlurredTextRingPro-module__umZRfq__heroTitle",
  "imgContainer": "BgBlurredTextRingPro-module__umZRfq__imgContainer",
  "imgDesktop": "BgBlurredTextRingPro-module__umZRfq__imgDesktop",
  "imgMobile": "BgBlurredTextRingPro-module__umZRfq__imgMobile",
  "root": "BgBlurredTextRingPro-module__umZRfq__root",
});
